webpackJsonp([3],{

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_views_ModalView__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/**
 * Created by Mike Naughton on 6/22/17.
 *
 * Locks down page navigation until successfully bootstrapped
 */



(function () {
  var modalView;
  var destination = location.pathname;
  var _once = function (func) {
    var times = 2;
    var memo;

    return function () {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }

      if (times <= 1) func = null;

      return memo;
    };
  };

  var boundFunction = _once(function (event) {
    var href = event.target.getAttribute("href");
    var modalClass = "app-boot";
    var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".app-boot");

    if ($el.length <= 0) {
      $el = null;
    }

    event.preventDefault();
    destination = href;
    modalView = new __WEBPACK_IMPORTED_MODULE_0_core_views_ModalView__["a" /* default */]({
      title: "Loading",
      locked: true,
      modalClass: modalClass,
      el: $el,
    });
    modalView.render();
    modalView.inProgress(true);
    modalView.show();
  });
  var clickHandler = function (evt) {
    if (
      evt.target.tagName.toLowerCase() == "a" &&
      evt.target.getAttribute("href").indexOf("/") === 0
    ) {
      // the '/' meaning it's to this site
      boundFunction(evt);
    }
  };

  document.addEventListener("click", clickHandler);

  window.hideLoad = function () {
    if (modalView) modalView.hide();
    document.removeEventListener("click", clickHandler);
    return {
      path: destination,
      view: modalView,
    };
  };
})();


/***/ })

},[976]);


// WEBPACK FOOTER //
// lock.80b4fca6872d78b57237.bundle.js